import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/App';
import { Services } from './services/services';

// let webSocket = new WebSocket(`wss://${location.host}/api/ws/web`);
// webSocket.onmessage = (event) => {
//   console.log('from socket:', event.data);
// };
// webSocket.onopen  = () => {
//   console.log('websocket inited');
// };


let services: Services = new Services()

const rootElem = document.getElementById('root');
if (rootElem) {
  createRoot(rootElem).render(
    // <React.StrictMode>
      <BrowserRouter>
        <App  services={services}/>
      </BrowserRouter>
    // </React.StrictMode>
  );
} else alert('Cannot find element with id "root", something went wrong');

